module.exports = __webpack_public_path__ + "img/home-index-menu1.f3aee126.png";